import { z } from 'zod';

import { InstanceIdType } from '#schema/defs';

export const CogniteFileModel = z.object({
  ...InstanceIdType.shape,

  name: z.string().optional(),
  tags: z.string().array().optional(),
  assets: InstanceIdType.array().optional(),
  mimeType: z.string().optional(),
  directory: z.string().optional(),
  isUploaded: z.boolean().optional(),
  uploadedTime: z.coerce.date().optional(),
  sourceContext: z.string().optional(),
});

export type CogniteFileModelInput = z.input<typeof CogniteFileModel>;
export type CogniteFileModelOutput = z.output<typeof CogniteFileModel>;
